import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.string.replace-all.js";
import { contractPlanList, delContract } from './../request';
import planModel from './planModel.vue';
import topTitle from '@/components/title';
import planSeeModel from './planSeeModel.vue';
export default {
  components: {
    planModel,
    topTitle,
    planSeeModel
  },
  props: ['id', 'infoObj', 'type'],
  data() {
    return {
      palnShow: false,
      palnSeeShow: false,
      data: [],
      columns: [{
        slots: {
          title: '产品代码'
        },
        dataIndex: 'code',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'premium',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '缴费期限'
        },
        dataIndex: 'paymentDeadlineName',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'paymentDeadlineName'
        }
      }, {
        slots: {
          title: '保障期限'
        },
        dataIndex: 'durationName',
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'durationName'
        }
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 150,
        key: '6'
      }],
      replaceName: ['年交', '月交', '季交', '周交', '年', '天']
    };
  },
  created() {
    setTimeout(() => {
      this.getDataFun();
    }, 400);
  },
  methods: {
    replaceFn(value) {
      let _replaceName = this.replaceName;
      _replaceName.forEach(item => {
        value = value.replaceAll(item, this.$t(item));
      });
      return this.$t(value);
    },
    getDataFun() {
      contractPlanList({
        contractId: this.id
      }).then(res => {
        console.log(res, 556);
        this.data = res;
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该方案') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delContract({
          contractId: val.contractId
        }).then(res => {
          _this.$message.success(_this.$t('操作成功') + '!');
          _this.getDataFun();
        });
      });
    },
    planFun(val) {
      console.log(222);
      this.palnShow = true;
      this.$nextTick(() => {
        this.$refs.palnForm.init(val);
      });
    },
    seeFun(val) {
      this.palnSeeShow = true;
      this.$nextTick(() => {
        this.$refs.palnSeeForm.init(val);
      });
    }
  }
};